<template>
  <div ref="container">
    <div
      ref="text"
      :class="$style.white"
      v-show="content"
      v-html="richContent"></div>
  </div>
</template>

<script>
/*
 * flow: enable CodeCopy - CodeLines - init EasyMarker - highLightNotes - init MathJax - highLightNotes
 */
import utils from '../../utils'
import Hljs from '../../utils/highlight-line-number.js'
import Hls from 'hls.js'
import PerfectScrollbar from 'perfect-scrollbar'

export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      preViewImg: false,
      imgUrl: '',
      // richContent: '',
      noteSelections: [],
      newVideos: []
    }
  },
  computed: {
    richContent () {
      return utils.formatContent(this.content)
    }
  },
  watch: {
    richContent () {
      this.handleMathJax(this.richContent)
    }
  },
  mounted () {
    this.initVideo()
    this.$el.addEventListener('copy', this.copyHandler)
    this.$nextTick(() => {
      this.initPrecodecopy()
    })

    // 代码块加行号
    const blocks = this.$el.querySelectorAll('pre code')
    Array.prototype.forEach.call(blocks, block => {
      Hljs.lineNumbersBlock(block, { singleLine: true })
    })

    // 渲染数学公式
    this.handleMathJax(this.richContent)

    this.$refs.container.querySelectorAll('pre code').forEach(dom => {
      const ps = new PerfectScrollbar(dom, {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20,
        suppressScrollY: true
      })
      setTimeout(() => {
        ps.update()
      }, 1)
    })

    // 预防文章默认跳转
    this.$refs.container.querySelectorAll('a').forEach(item => {
      item.onclick = function (event) {
        const link = event.target.href || event.target.parentNode.href
        if (link.match(/^time:\/\//)) {
          const arr = link.match(/url=(.+)/i)
          if (arr.length > 1) {
            window.open(decodeURIComponent(arr[1]))
          }
        }
        if (link.match(/^http/)) {
          window.open(link)
        }
        event.preventDefault()
      }
    })
  },
  beforeDestroy () {
    this.$el.removeEventListener('copy', this.copyHandler)
    this.newVideos.forEach(video => {
      video.removeEventListener('play', this.videoPlayHandle)
    })
  },
  updated () {
    this.$nextTick(() => {
      this.initVideo()
    })
  },
  methods: {
    // <pre>内的代码可复制
    initPrecodecopy () {
      var pres = document.querySelectorAll('pre')
      pres.forEach(pre => {
        pre.style.position = 'relative'
        var code = pre.querySelector('code')
        if (!code) return
        const textContent = code.textContent
        const copyBtn = document.createElement('div')
        copyBtn.innerHTML = '<div class="copy"><span class="iconfont">&#xe676;</span>复制代码<div class="tooltip"></div></div>'
        copyBtn.classList.add('richcontent-pre-copy')
        pre.appendChild(copyBtn)
        copyBtn.addEventListener('click', e => {
          let tooltipNode = copyBtn.querySelector('.tooltip')
          const input = document.createElement('textarea')
          input.setAttribute('readonly', 'readonly') // 防止 iPhone 弹出键盘
          input.style.position = 'absolute' // 防止 Firefox Edge 滚动到页面最下方
          var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
          input.style.top = `${top + 256}px`
          input.style.opacity = '0'
          document.body.appendChild(input)
          input.textContent = textContent.replace(/^\$ /, '')
          input.focus()
          input.setSelectionRange(0, input.textContent.length)
          tooltipNode.innerHTML = document.execCommand('copy') ? '已复制' : '复制失败'
          tooltipNode.classList.add('show')
          setTimeout(() => {
            tooltipNode.classList.remove('show')
          }, 1500)
          // input.select() // Safari 使用这个 api 不会选中
          document.body.removeChild(input)
        })
      })
    },
    handleMathJax (content) {
      // 数学公式，如果正文里包含 $ 则加载 MathJax 脚本
      if (content.indexOf('$') > -1) {
        utils.handleMathJax(this.$el)
      }
    },
    initVideo () {
      const videos = this.$refs.text.querySelectorAll('video')
      if (videos.length > 0) {
        Array.prototype.slice.call(videos).forEach(video => {
          if (video.attributes['x5-playsinline']) {
            return
          }
          let poster = video.attributes.poster
          poster = poster ? poster.value : ''
          const parent = video.parentElement
          const width = parent.offsetWidth
          const height = Math.floor(186 / 331 * width)
          const container = document.createElement('div')
          const src = video.lastChild.attributes.src.value
          container.innerHTML = `<video style="vertical-align: top;width:${width}px;height:${height}px" webkit-playsinline playsinline x5-playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true" src="${src}" controls="controls" poster="${poster}"></video>`
          parent.insertBefore(container, video)
          parent.removeChild(video)
          const newVideo = parent.querySelector('video')
          const hls = new Hls()
          hls.loadSource(src)
          hls.attachMedia(newVideo)
        })
      }
    }
  }
}
</script>

<style lang="stylus" module>
$fontsize = 16px
$maincolor = #303030
$p_marginbottom = 30px
$color-primary = #1458D4

.white
  font-weight 400
  color $maincolor
  line-height 1.76
  white-space normal
  word-break normal
  font-size $fontsize
  // background #fff
  transition background-color .3s ease
  :global
    .MathJax_Display
      overflow auto

    .poster
      position fixed
      left -10000px
      top -10000px
      overflow hidden
      padding 1rem
      background #ECECEC

    .richcontent-pre-copy
      font-size 13px
      color #888
      position absolute
      right 1em
      top 0.5em
      cursor pointer
      user-select none

    .richcontent-pre-copy .iconfont
      font-size 12px
      margin-right 0.2em
    a
      color $color-primary
      border-bottom 1px solid $color-primary
    img
      display block
      max-width 100%
      position relative
      left 50%
      transform translateX(-50%)
      background-color #EEE
      vertical-align top
      border-radius 0px

    audio,
    video
      width 100%
      background-color #EEE

    pre
      margin-top 16px
      padding-left 0
      padding-right 0
      padding-top 34px
      padding-bottom 0
      margin-bottom 30px
      position relative
      border-radius 6px
      background #F6F7FBBF
      border 0
    code
      word-break break-all
    pre code
      font-size 12px
      font-family Consolas,"Liberation Mono",Menlo,monospace,Courier
      display block
      word-break normal
      box-sizing border-box
      margin-left 16px
      margin-right 16px
      overflow-x scroll
      &:after
        content ''
        height 30px
        width 100%
        display block

    hr
      border none
      margin-top 1.5rem
      margin-bottom 1.5rem
      border-top #F5F5F5 solid 1px
      height 1px
      background none

    h1,
    h2,
    h3,
    h4,
    h5
      margin-bottom 20px
      margin-top 0px
      font-weight bold
      color $maincolor
    b,
    strong
      font-weight bold
      color $maincolor
    for index in 1 2 3 4 5
      h{index}
        font-size $fontsize + (5 - index)

    center,
    p
      font-weight 400
      color $maincolor
      margin-top 0
      margin-bottom $p_marginbottom
      word-break break-word

    center
      text-align center

    blockquote
      margin-left 15px
      margin-top 0
      margin-bottom $p_marginbottom + 4
      border-left 4.5px solid #e8e8e8
      padding-left 17px
      color #999
      p
        margin-top 0
        margin-bottom 0
        color #999

    ol, ul
      margin-bottom $p_marginbottom
      p
        margin-top 0

    ol
      list-style decimal
      margin-left 30px

    ul
      li
        padding-left 17px
        position relative
        margin-bottom 10px
        &:after
          content ''
          height 6px
          width 6px
          border-radius 50%
          background $maincolor
          position absolute
          top 10px
          left 0

    .orange
      color $color-primary

    .reference
      color #888

    .m-right
      text-align right

    .m-center
      text-align center
      display block

    .m-gray
      color #888

    .m-small
      font-size $fontsize - 2
    table
      margin-bottom 1.5rem
      width 100%
      line-height 1.8
      th, td, caption
        border 1px solid #ddd
        padding 0.5em 1em
      thead
        th
          background rgba(241, 241, 241, 0.7)
    table
      caption
        border-bottom none

    table.hljs-ln
      box-sizing border-box
      margin-bottom 0
      border-spacing 0
      border-collapse collapse

    table.hljs-ln tbody
      box-sizing border-box

    table.hljs-ln tr
      box-sizing border-box

    table.hljs-ln td
      box-sizing border-box
      padding 0
      border 0

    table.hljs-ln td.hljs-ln-numbers
      min-width 15px
      font-family "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace
      font-size 12px
      line-height 20px
      color rgba(27,31,35,0.3)
      text-align right
      white-space nowrap
      vertical-align top
      cursor pointer
      user-select none

    table.hljs-ln td.hljs-ln-code
      position relative
      padding-right 10px
      padding-left 10px
      line-height 20px
      vertical-align top
      overflow visible
      font-family "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace
      font-size 13px
      color #666666
      word-wrap normal
      white-space pre

.small
  font-size $fontsize - 2
  for index in 1 2 3 4 5
    h{index}
      font-size $fontsize - 2 + (5 - index)
  p
    margin-bottom $p_marginbottom - 4
  blockquote
    margin-bottom $p_marginbottom
  ol, ul
    margin-bottom $p_marginbottom - 4
  :global
    .m-small
      font-size $fontsize - 4

.big
  font-size $fontsize + 2
  for index in 1 2 3 4 5
    h{index}
      font-size $fontsize + 2 + (5 - index)
  :global
    .m-small
      font-size $fontsize

.android
  :global
    table.hljs-ln td.hljs-ln-numbers,
    table.hljs-ln td.hljs-ln-code
      font-family monospace

</style>
